'use client'
import { LoginContainer } from '@/containers'

export default function LoginPage() {
  return <LoginContainer />
}
